import { IconHistory } from "@tabler/icons-react"
import { ActionIcon } from "@tfg/ui"
import { useTranslation } from "react-i18next"

type DatapointResponseVersionsTriggerProps = {
  readonly onClick: () => void
}

export const DatapointResponseVersionsTrigger = ({
  onClick,
}: DatapointResponseVersionsTriggerProps) => {
  const { t } = useTranslation("products")

  return (
    <ActionIcon
      icon={<IconHistory />}
      variant="ghost"
      size={16}
      stroke={1.5}
      toolTip={t("details.responseVersions.open")}
      aria-label={t("details.responseVersions.open")}
      onClick={onClick}
    />
  )
}
